"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-non-null-assertion */
var inertia_react_1 = require("@inertiajs/inertia-react");
var react_1 = __importStar(require("react"));
var Banner_1 = __importDefault(require("@/Jetstream/Banner"));
var Sidebar_1 = __importDefault(require("@/Components/Sidebar/Sidebar"));
var Topbar_1 = __importDefault(require("@/Components/Topbar/Topbar"));
var i18n_1 = __importDefault(require("../Components/i18n"));
var Loading_1 = __importDefault(require("@/Components/common/Loading"));
var AcceptTermsModal_1 = __importDefault(require("@/Components/AcceptTermsModal"));
var useTypedPage_1 = __importDefault(require("@/Hooks/useTypedPage"));
var AppLayout_module_css_1 = __importDefault(require("./AppLayout.module.css"));
function AppLayout(_a) {
    var title = _a.title, renderHeader = _a.renderHeader, children = _a.children;
    var page = (0, useTypedPage_1.default)();
    (0, react_1.useEffect)(function () {
        if (i18n_1.default.language != page.props.user.language_format)
            i18n_1.default.changeLanguage(page.props.user.language_format);
    }, [page.props.user.language_format]);
    return (react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(Loading_1.default, null) },
        react_1.default.createElement("div", { className: AppLayout_module_css_1.default.main_page },
            react_1.default.createElement(AcceptTermsModal_1.default, null),
            react_1.default.createElement(inertia_react_1.Head, { title: title }),
            react_1.default.createElement(Banner_1.default, null),
            react_1.default.createElement("div", { className: "d-none d-sm-block" },
                react_1.default.createElement(Sidebar_1.default, null)),
            react_1.default.createElement("div", { className: "min-h-screen w-100" },
                react_1.default.createElement("div", { className: AppLayout_module_css_1.default.top_bar_content_container },
                    react_1.default.createElement(Topbar_1.default, { renderHeader: renderHeader })),
                react_1.default.createElement("div", { className: AppLayout_module_css_1.default.main }, children)))));
}
exports.default = AppLayout;
